import { webStorage } from 'sidecar-utility-library'

import { locKeys } from './ipInfo'

/**
 * Given an action and a regex, this fn determines if the action is "relevant"
 * by comparing the action type against a regex.
 *
 * @param {object} action The action in question
 * @param {regex | array} relevantActions A regex or array of regexes
 */
export const isActionRelevant = (action, relevantActions) => {
  const isRelevant = Array.isArray(relevantActions)
    ? relevantActions.some(regex => regex.test(action.type))
    : relevantActions.test(action.type)

  return !(!action.type || !isRelevant)
}

const keysToSave = [...locKeys, 'sidecar-doctor-modal-shown']

/** Clears webStorage except for important info that we'll want to keep */
export const clearWebStorage = () => {
  // save the values for each key
  const savedInfo = [...keysToSave].reduce(
    (acc, cur) => ({
      ...acc,
      [cur]: webStorage.getItem(cur),
    }),
    {},
  )
  // we want to keep the anonUserId from LaunchDarkly so that
  // this member can remain identified and not count as a new user.
  const ldAnonUserId = webStorage.getItem('ld:$anonUserId')

  webStorage.clear()

  // put humpty dumpty sort of together again with the info we saved above.
  Object.entries(savedInfo).forEach(([k, v]) => webStorage.setItem(k, v))
  webStorage.setItem('ld:$anonUserId', ldAnonUserId)
}
